import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { OrgaoJustica } from '../orgao-justica.model';
import { OrgaoJusticaService } from '../orgao-justica.service';
import { SegmentoJusticaEnum } from '../../enums/segmentoJustica';
import { SelectItemHelper } from '../../enums/select-item-helper';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { Frm } from '../../components/frm/frm.interface';

@Component({
  selector: 'app-orgao-justica-frm',
  templateUrl: './orgao-justica-frm.component.html',
  styleUrls: ['./orgao-justica-frm.component.css'],
})
export class OrgaoJusticaFrmComponent implements OnInit, Frm<OrgaoJustica, number> {
  public entidade: OrgaoJustica;
  public segmentoItens: SelectItem[];

  constructor(
    private service: OrgaoJusticaService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService
  ) {}

  ngOnInit(): void {
    this.segmentoItens = SelectItemHelper.enumToSelectItem(SegmentoJusticaEnum);
  }

  iniciarAlteracao(): void {}

  iniciarAlteracaoPorId(): void {}

  iniciarInsercao(): void {}

  salvar(): void {}
}
